/**
 * This file is part of Paper Shaders for Gutenberg.
 *
 * Paper Shaders for Gutenberg is free software: you can redistribute it and/or modify it
 * under the terms of the GNU General Public License as published by the Free
 * Software Foundation, either version 2 of the License, or any later version.
 *
 * Paper Shaders for Gutenberg is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
 * or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License for
 * more details.
 *
 * You should have received a copy of the GNU General Public License along with
 * Paper Shaders for Gutenberg.  If not, see <https://www.gnu.org/licenses/>.
 */

import { createRoot } from "@wordpress/element";
import Shader from "./shader";
import './shader.scss';

document
	.querySelectorAll( '.wp-block-tandem-paper-shader-halftone-cmyk' )
	.forEach( function ( element ) {
		const root = createRoot( element );
		root.render( <Shader
			image={ element.dataset.image ?? "https://paper.design/flowers.webp" }
			colorBack={ element.dataset.colorBack }
			colorC={ element.dataset.colorC }
			colorM={ element.dataset.colorM }
			colorY={ element.dataset.colorY }
			colorK={ element.dataset.colorK }
			size={ element.dataset.size }
			gridNoise={ element.dataset.gridNoise }
			type={ element.dataset.type }
			softness={ element.dataset.softness }
			contrast={ element.dataset.contrast }
			floodC={ element.dataset.floodC }
			floodM={ element.dataset.floodM }
			floodY={ element.dataset.floodY }
			floodK={ element.dataset.floodK }
			gainC={ element.dataset.gainC }
			gainM={ element.dataset.gainM }
			gainY={ element.dataset.gainY }
			gainK={ element.dataset.gainK }
			grainSize={ element.dataset.grainSize }
			grainMixer={ element.dataset.grainMixer }
			grainOverlay={ element.dataset.grainOverlay }
			scale={ element.dataset.scale }
			fit={ element.dataset.fit }
		/> );
	} );
